{
  "contactModal": {
    "delete": {
      "cancel": "取消",
      "confirm": "删除",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "您确定要删除此联系人吗？",
      "success": "success",
      "title": "删除联系人"
    }
  },
  "contacts": {
    "buttons": {
      "add": "添加联系人"
    },
    "table": {
      "headers": {
        "actions": "操作",
        "email": "邮箱",
        "id": "ID",
        "name": "姓名"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "激活账户",
      "back": "← 返回",
      "next": "下一步"
    },
    "ariaLabel": "入门步骤",
    "gate": {
      "retryBanner": {
        "message": "发生错误。请刷新并重试。",
        "retry": "重试"
      }
    },
    "placeholder": "步骤内容即将推出。",
    "stepIndicator": "第 {{current}} 步，共 {{total}} 步",
    "steps": {
      "my_facilities": {
        "name": "设施",
        "subtitle": "告诉我们您正在使用哪些生产设施及其母公司。",
        "title": "添加您的生产设施"
      },
      "register_bp": {
        "name": "商业伙伴",
        "subtitle": "列出合作伙伴组织的关键联系人——我们应联系以进行可追溯性请求的买家、代理或分包商。",
        "title": "添加您的商业伙伴"
      },
      "review": {
        "name": "审核",
        "subtitle": "在激活您的账户之前，请确认所有信息正确。",
        "title": "审核您的详细信息"
      },
      "verify_company": {
        "name": "验证公司",
        "subtitle": "在继续之前，请确认我们记录了正确的企业信息。",
        "title": "验证您的公司资料"
      },
      "welcome": {
        "name": "欢迎",
        "subtitle": "",
        "title": "欢迎使用 Trace for Good"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "在访问您的 Trace for Good 账户之前，我们需要与您核实一些信息。",
      "intro": "欢迎您的加入。本门户旨在在产品质量追溯与合规背景下，促进多条供应链中业务伙伴之间的协作。",
      "invitation": "您已由 <strong>{{invitingCompanyName}}</strong> 邀请加入 Trace for Good 平台，参与产品追溯流程。该流程可能需要您提供供应链相关信息。"
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "添加注册 ID",
      "backToProductionSite": "返回设施表单",
      "cancel": "取消",
      "delete": "删除",
      "removeRegistrationId": "删除注册 ID",
      "save": "保存"
    },
    "createTitle": "新建生产站点",
    "delete": {
      "cancel": "取消",
      "confirm": "删除",
      "message": "您确定要删除此生产站点吗？",
      "title": "删除生产站点"
    },
    "editTitle": "编辑生产站点",
    "errors": {
      "cityRequired": "城市是必填的",
      "coordinatesMaxDecimals": "纬度和经度最多只能有 6 位小数",
      "countryMustBeValid": "国家必须是有效的 (例如 FR, DE)",
      "internalCodeTooLong": "内部代码必须少于 32 个字符",
      "nameRequired": "名称是必填的",
      "parentCompanyRequired": "母公司为必填项",
      "postalCodeTooShort": "邮编必须至少有 3 个字符",
      "streetRequired": "街道是必填的",
      "streetTooShort": "街道必须至少有 3 个字符"
    },
    "labels": {
      "city": "城市",
      "country": "国家",
      "internalCode": "内部代码",
      "latitude": "纬度",
      "longitude": "经度",
      "name": "生产站点名称",
      "parentCompany": "母公司",
      "performedActivities": "执行活动",
      "postalCode": "邮编",
      "registrationId": "设施注册编号",
      "street": "街道"
    },
    "parentCompanyChange": {
      "cancel": "保留当前母公司",
      "confirm": "更改母公司",
      "message": "母公司是该站点所属的公司。更改它将更新该设施的所有权，并可能影响可追溯性路由。",
      "title": "更改母公司？"
    },
    "placeholders": {
      "city": "例如：达卡",
      "country": "选择设施所在国家",
      "internalCode": "例如：BD-DAK-001或您的内部编号",
      "latitude": "例如：48.8566",
      "longitude": "例如：2.3522",
      "name": "例如：达卡裁剪缝制车间A",
      "parentCompany": "例如：阿里巴巴集团",
      "performedActivities": "例如：裁剪、缝制、后整理、染色",
      "postalCode": "例如：1207",
      "registrationId": "例如：增值税号、CIN、GSTIN、USC",
      "street": "例如：贝克街221B号"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS：9 位数字。",
      "EORI": "EORI：国家代码 + 14 位数字。",
      "GLN": "GLN：13 位数字。",
      "OTHER": "其他：最多 32 个字符。",
      "RCS": "RCS：RCS + 空格 + 公司名称 + 空格 + [A,B] + 空格 + 9 位数字。",
      "VAT": "VAT：国家代码（如 FR）+ 2 位 + 9 位 SIREN 号。"
    },
    "registrationIdErrors": {
      "DUNS": "DUNS 注册 ID 须为 9 位数字。",
      "EORI": "EORI 注册 ID 格式须为：国家代码（如 FR）+ 14 位数字。",
      "GLN": "GLN 注册 ID 须为 13 位数字。",
      "OTHER": "其他注册 ID 须少于 32 个字符。",
      "RCS": "RCS 注册 ID 格式须为：RCS + 空格 + 公司名称 + 空格 + [A,B] + 空格 + 9 位数字。",
      "VAT": "VAT 注册 ID 格式须为：国家代码（如 FR）+ 2 位键 + 9 位 SIREN 号。"
    },
    "tabs": {
      "generalInfo": "基本信息",
      "location": "位置"
    },
    "tooltips": {
      "address": "地址",
      "city": "城市",
      "country": "国家",
      "internalCode": "内部代码",
      "latitude": "纬度",
      "longitude": "经度",
      "name": "名称",
      "parentCompany": "拥有该设施的母公司，从已注册的商业合作伙伴列表中选择。",
      "parentCompanyEdit": "选择拥有该站点的公司。",
      "parentCompanyReadOnly": "只有创建或拥有该设施的组织才能更改母公司。",
      "performedActivities": "执行活动",
      "postalCode": "邮编",
      "registrationId": "设施注册编号",
      "street": "街道"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "添加生产站点"
    },
    "create": {
      "error": "添加生产站点时出错",
      "successCreated": {
        "message": "生产站点已成功添加",
        "title": "生产站点添加成功"
      },
      "successMerged": {
        "message": "您的资源库中已存在具有此名称和地址的生产站点。",
        "title": "找到现有生产站点"
      }
    },
    "delete": {
      "error": "删除生产站点时出错",
      "success": {
        "message": "生产站点已成功删除",
        "title": "生产站点删除成功"
      }
    },
    "filters": {
      "country": "国家",
      "internalCode": "内部代码",
      "isConfidential": "保密",
      "isConfidentialFalse": "否",
      "isConfidentialTrue": "是",
      "name": "生产站点名称",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "执行活动",
      "searchPlaceholder": "搜索过滤器",
      "title": "过滤器"
    },
    "search": {
      "placeholder": "搜索名称或地址"
    },
    "sorts": {
      "address": "地址",
      "country": "国家",
      "email": "邮箱",
      "internalCode": "内部代码",
      "name": "名称"
    },
    "table": {
      "headers": {
        "address": "地址",
        "certificates": "证书",
        "deleted": "已删除",
        "id": "ID",
        "internalCode": "内部代码",
        "name": "名称",
        "parentCompany": "母公司",
        "performedActivities": "执行活动",
        "registrationId": "设施注册编号"
      }
    },
    "title": "生产站点",
    "update": {
      "error": "更新生产站点时出错",
      "partialSave": {
        "message": "message"
      },
      "success": {
        "message": "生产站点已成功更新",
        "title": "生产站点更新成功"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "错误"
    }
  }
}
